(function () {
	'use strict';

	const modules = [];

	angular.module('MiscellaneousSettingsModule', modules);
})();
